const partNumberStrings = {
    // Recalibration
    MOBILE_STATIC_RECAL_FEE: "RECAL MOBILE",
    MOBILE_DUAL_RECAL_FEE: "RECAL MOBILEDUAL",
    DONATION: "DONATION",
    // Fees
    RECYCLE_FEE: "RECYCLE FEE",
    PRICING_BY_DAY_UPCHARGE: "PREMAPPT GEN",
};

export { partNumberStrings };
